import { PartnerSource } from '../enums';
import { PartnerConfig, PartnerLocaleType, PartnerProductLine } from './Partner';

// eslint-disable-next-line no-shadow
export enum PartnerProfileResourceSectionType {
  RelatedResources = 'related_resources',
  Resources = 'resources',
  Media = 'media',
  Articles = 'articles',
}

// eslint-disable-next-line no-shadow
export enum PartnerProfileResourceType {
  PDF = 'pdf',
  VIDEO = 'video',
  ARTICLE = 'article',
  CASE_STUDY = 'case_study',
  DOC = 'doc',
  OTHER = 'other',
}

export interface PartnerBenefitTranslation {
  locale: PartnerLocaleType,
  partnerId: string,
  title?: string,
  description?: string,
  position?: number;
  isEnabled: boolean;
  isBenefit?: boolean;
}

export interface PartnerOfferTranslation {
  locale: PartnerLocaleType,
  partnerId: string,
  title?: string,
  description?: string,
  position?: number;
  isEnabled: boolean;
}

export interface PartnerResourceTranslation {
  locale: PartnerLocaleType,
  partnerId: string,
  resourceLink: string,
  resourceSection: PartnerProfileResourceSectionType,
  resourceType: PartnerProfileResourceType,
  title: string,
  subtitle?: string,
  thumbnailUrl?: string,
  position?: number;
  isInternal: boolean;
}

export interface PartnerContact {
  partnerId: string,
  name: string;
  jobTitle?: string;
  addressStreet?: string;
  addressCity?: string;
  addressState?: string;
  addressCountry?: string;
  addressZip?: string;
  email?: string;
  website?: string;
  phone?: string;
}

export interface PartnerProfileConfig {
  id: string
  code: string
  name: string
  source: PartnerSource
  partnerOffers: PartnerOfferTranslation[]
  partnerBenefits: PartnerBenefitTranslation[]
  partnerResources: PartnerResourceTranslation[]
  partnerContacts: PartnerContact[]
  partnerProductLines: PartnerProductLine[]
  config: PartnerConfig
}
